export default "__VITE_ASSET__Bkm9e7uf__"